export default __webpack_public_path__ + "static/media/nft19.0d4923c0.png";